import 'rxjs/add/operator/map';

import { Injectable } from '@angular/core';

import { ApiProvider } from '../api/api';
import {
  EnvironmentProvider,
  ServerEnvironment,
} from '../environment/environment';
import { LoadingAlertProvider } from '../loading-alert/loading-alert';
import { SessionProvider } from '../session/session';
import { UserProvider } from '../user/user';

@Injectable()
export class AnalyticsProvider {
  static readonly USER_ATTRIBUTION_KEY = 'user_attribution';

  constructor(
    private environment: EnvironmentProvider,
    private api: ApiProvider,
    private userService: UserProvider,
    private session: SessionProvider,
    private loadingAlert: LoadingAlertProvider
  ) {
    console.log('Hello AnalyticsProvider Provider');
  }

  setup() {
    this.userService.currentUser$.subscribe(user => {
      if (user) {
        this.setUser(user.uid);
        this.handleStoredDeeplink();
      }
    });
  }

  setUser(uid) {
    /* no op */
  }

  trackView(title: string) {
    if (this.userService.isLoggedIn$.value) {
      this.trackServerPageView(title);
      console.log('Server: track event', title);
    }
  }

  trackEvent(eventName: string) {
    if (this.userService.isLoggedIn$.value) {
      this.trackServerEvent(eventName);
      console.log('Server: track event', eventName);
    }
  }

  private trackServerEvent(eventName: string) {
    this.api
      .call({
        url: '/analytics',
        method: 'POST',
        body: { event_name: eventName },
      })
      .subscribe(
        response => {
          console.log('Tracked server event');
        },
        error => {
          console.log('Error tracking event', error);
        }
      );
  }

  private trackServerPageView(pageName: string) {
    this.api
      .call({
        url: '/page_views',
        method: 'POST',
        body: { page_name: pageName },
      })
      .subscribe(
        response => {
          console.log('Tracked server page view');
        },
        error => {
          console.log('Error tracking page view', error);
        }
      );
  }

  handleDeeplink(data: DeepLinkData) {
    let user = this.userService.currentUser$.getValue();
    if (data.user_uid && data.auth_key) {
      this.loadingAlert.showLoaderWithText('Logging in');
      this.userService
        .logout()
        .then(() => {
          if (data.environment == 'beta') {
            return this.environment.switchServer(ServerEnvironment.Beta);
          }
        })
        .then(() => {
          this.userService.loginWithAuthKey(data.auth_key, data.user_uid).then(
            () => {
              this.loadingAlert.dismissLoader();
            },
            () => {
              this.loadingAlert.dismissLoader();
              this.loadingAlert.showToastAlert('Error logging in');
            }
          );
        });
    } else if (user) {
      this.attributeUser(data);
    } else {
      this.session.set(AnalyticsProvider.USER_ATTRIBUTION_KEY, data);
    }
  }

  private handleStoredDeeplink() {
    this.session
      .get(AnalyticsProvider.USER_ATTRIBUTION_KEY)
      .then((data: DeepLinkData) => {
        if (data) {
          this.handleDeeplink(data);
          this.session.remove(AnalyticsProvider.USER_ATTRIBUTION_KEY);
        }
      });
  }

  private attributeUser(data: DeepLinkData) {
    let stringifiedData = JSON.stringify(data);
    this.userService.updateUser({
      ref: data.ref,
      deepLinkData: stringifiedData,
    });
  }
}

interface DeepLinkData {
  user_uid?: string;
  auth_key?: string;
  ref?: string;
  environment?: 'beta' | 'prod';
}



// WEBPACK FOOTER //
// ./src/providers/analytics/analytics.ts